import React, { ComponentProps, PropsWithChildren } from 'react'

import useMediaQuery from '@/hooks/useMediaQuery'
import { cn } from '@/lib/utils'

import {
  DropdownMenu as DropdownMenuRoot,
  DropdownMenuContent,
  // DropdownMenuItem,
  DropdownMenuTrigger
} from '../ui/dropdown-menu'

// export { DropdownMenuItem }

type DropdownMenuProps = ComponentProps<typeof DropdownMenuRoot> & {
  trigger: ComponentProps<typeof DropdownMenuTrigger>
  content?: Omit<ComponentProps<typeof DropdownMenuContent>, 'children'>
  secondary?: boolean
}

const DropdownMenu: React.FC<PropsWithChildren<DropdownMenuProps>> = ({
  children,
  trigger,
  content,
  secondary,
  ...rest
}) => {
  const { children: triggerChildren, ...triggerProps } = trigger
  const { className: contentClassName, ...contentProps } = content || {}

  const { gtXL } = useMediaQuery()

  return (
    <DropdownMenuRoot {...rest}>
      <DropdownMenuTrigger {...triggerProps}>
        {triggerChildren}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align={gtXL ? 'end' : 'start'}
        sideOffset={secondary ? 8 : 12}
        className={cn(
          'mx-2 w-[calc(100vw-16px)] rounded-md xs:mx-4 xs:w-[calc(100vw-32px)] md:mx-0 md:w-auto',
          secondary ? 'bg-popover-secondary p-2 xl:p-4' : 'p-4 xl:p-6',
          contentClassName
        )}
        {...contentProps}
      >
        {children}
      </DropdownMenuContent>
    </DropdownMenuRoot>
  )
}

export default DropdownMenu
